import { render, staticRenderFns } from "./Atendimento.vue?vue&type=template&id=320be9a7&scoped=true&"
import script from "./atendimento.ts?vue&type=script&lang=ts&"
export * from "./atendimento.ts?vue&type=script&lang=ts&"
import style0 from "./Atendimento.vue?vue&type=style&index=0&id=320be9a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320be9a7",
  null
  
)

export default component.exports